import {
    FiniteListWithAsyncLoaderAbstract,
    ListProps,
} from "shared/components/Components";
import { useMercuryContext } from "../context";

interface OliveDashboardsFilterProps extends ListProps {
    data?: any[];
}

class OliveDashboardsFilter extends FiniteListWithAsyncLoaderAbstract {
    async fetch() {
        const { context } = this.props as any;
        const props = this.props as unknown as OliveDashboardsFilterProps;

        if (props.data && props.data.length > 0) {
            return props.data.map((item: any) => ({
                title: item.name,
                value: item._id ?? item.id,
            }));
        } else {
            const { data } = await context.umsClient.get("/ums-v1/dashboards");

            const applications = Array.isArray(data) ? data : (data?.[0]?.documents ?? []);
            return applications.map((item: any) => ({
                title: item.name,
                value: item._id ?? item.id,
            }));
        }
    }
}

export default (props: OliveDashboardsFilterProps) => {
    const context = useMercuryContext();
    return <OliveDashboardsFilter context={context} {...props} />;
};
